import { createFileRoute } from "@tanstack/react-router";
import { ConnectorCreateForm } from "@/components/portal/connectors/ConnectorCreateForm";

export const Route = createFileRoute("/portal/connectors/mysql/new")({
  component: NewMysqlConnectorPage,
});

function NewMysqlConnectorPage() {
  return <ConnectorCreateForm typeSlug="mysql" />;
}
